// @flow

/**
 * The categories in which cookies and local storage items can be defined.
 */
export const Categories = {
  authentication: {necessary: true},
  'fraud-prevention': {necessary: true},
  security: {necessary: true},
  functionality: {necessary: true},
  preferences: {necessary: false, token: 'p'},
  statistics: {necessary: false, token: 's'},
  advertising: {necessary: false, token: 'a'},
};
